/**
 * 新建 ULD 时：前端核心状态 → 后端建档字段。
 * 丢失必须透传 initial_core_status，后端才会把核心状态写成丢失；
 * 其它值只映射兼容物理状态，核心状态仍按入库位置落在库。
 */
const CORE_TO_IATA = {
    IN_STOCK: "AVL",
    IN_TRANSIT: "AVL",
    OUT_OF_SERVICE: "UNS",
    RETIRED: "SCR",
    LOST: "LOST",
};

export function toCreateUldInitialStatusFields(initialCoreStatus) {
    const initial_status = CORE_TO_IATA[initialCoreStatus] || "AVL";
    if (initialCoreStatus === "LOST") {
        return { initial_status, initial_core_status: "LOST" };
    }
    return { initial_status };
}
